/* NDC: butonul „Comandă acum” – adaugă produsul personalizat (și serviciile bifate) în coș și duce direct la finalizarea comenzii (checkout).
   Validarea (text/machetă confirmată) și serviciile le face ndc-personalizer.js: butonul are data-ndc-buy, deci trece prin aceeași verificare.
   16.10 (HU): textele butonului vin din data-busy-label / data-error-msg (puse de Liquid pe /hu-hu/); fără ele – textele RO de până acum.
   Loguri [NDC-ORDER]. */
(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function log() {
    try { console.log.apply(console, ['[NDC-ORDER]'].concat(Array.prototype.slice.call(arguments))); } catch (e) {}
  }

  function setBusy(btn, busy) {
    btn.disabled = busy;
    btn.setAttribute('aria-busy', String(busy));
    var label = btn.querySelector('[data-ndc-order-label]');
    if (!label) return;
    if (!btn.dataset.label) btn.dataset.label = label.textContent;
    label.textContent = busy ? (btn.dataset.busyLabel || 'Se deschide finalizarea comenzii…') : btn.dataset.label;
  }

  function errorEl(btn) {
    var box = btn.closest('.ndc-order');
    return box && box.querySelector('[data-ndc-order-error]');
  }

  // Același produs (variantă + text) e deja în coș – ex. clientul revine din checkout: nu îl mai adăugăm a doua oară
  function alreadyInCart(fd) {
    var id = Number(fd.get('id'));
    var props = {};
    fd.forEach(function (v, k) {
      var m = /^properties\[(.+)\]$/.exec(k);
      if (m) props[m[1]] = String(v);
    });
    var keys = Object.keys(props);
    log('verific coșul | variantă =', id, '| chei =', keys.join(', ') || '-');
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (cart) {
        return (cart.items || []).some(function (it) {
          var p = it.properties || {};
          return it.variant_id === id && keys.length === Object.keys(p).length &&
            keys.every(function (k) { return String(p[k]) === props[k]; });
        });
      })
      .catch(function () { return false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ndc-order]');
    if (!btn || e.defaultPrevented || btn.disabled) return;
    var form = document.getElementById(btn.dataset.formId);
    if (!form) { log('formular lipsă:', btn.dataset.formId); return; }
    e.preventDefault();
    var fd = new FormData(form); // câmpurile goale sunt deja dezactivate de ndc-personalizer.js, deci nu se trimit
    var err = errorEl(btn);
    if (err) err.hidden = true;
    setBusy(btn, true);
    log('comandă acum | root =', ROOT, '| limbă =', document.documentElement.lang || '-');
    alreadyInCart(fd)
      .then(function (dup) {
        if (dup) { log('produsul e deja în coș – nu îl adaug din nou'); return; }
        return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
          .then(function (r) {
            if (r.ok) { log('adăugat în coș'); return; }
            return r.json().catch(function () { return {}; }).then(function (j) {
              throw new Error(j.description || j.message || '');
            });
          });
      })
      .then(function () { log('→ checkout'); window.location.href = ROOT + 'checkout'; })
      .catch(function (error) {
        log('eroare:', error && error.message);
        setBusy(btn, false);
        if (err) {
          err.textContent = (error && error.message) || btn.dataset.errorMsg || 'Nu am putut pregăti comanda. Încearcă din nou sau scrie-ne pe WhatsApp.';
          err.hidden = false;
        }
      });
  });

  // Revenire cu „Înapoi” din checkout: browserul restaurează bifa de confirmare, dar nu și textul – o scoatem;
  // din memoria browserului (bfcache) butonul poate rămâne „Se deschide…” – îl reactivăm
  window.addEventListener('pageshow', function (e) {
    document.querySelectorAll('[data-ndc-perso]').forEach(function (r) {
      var c = r.querySelector('[data-ndc-confirm]');
      if (!c || !c.checked) return;
      var filled = Array.prototype.some.call(
        r.querySelectorAll('[data-ndc-street], [data-ndc-number], [data-ndc-text]'),
        function (el) { return String(el.value || '').trim(); }
      );
      if (!filled) { c.checked = false; log('pageshow: bifa de confirmare scoasă (text gol)'); }
    });
    if (!e.persisted) return;
    document.querySelectorAll('[data-ndc-order]').forEach(function (b) { setBusy(b, false); });
  });
})();
